var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41 40",
    style: {
      enableBackground: "new 0 0 41 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#070707;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.4904,
    y1: 9.2476,
    x2: 26.9904,
    y2: 34.7476,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC16E",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE73C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,18c0,4.4-10.4,18-11.5,18s-2-3.6-2-8c0-4,2.8-19.4,4.2-22.1c0.2-0.3,0.5-0.4,0.9-0.2 C28.6,7.8,30.5,13.7,30.5,18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.7,32.1l-0.8-0.6L22.7,32.1z M14.3,32.1l-0.8,0.6L14.3,32.1z M18.5,35.5v-1V35.5z M29.5,16.9 c0,1.9-1,4.4-2.5,7c-1.5,2.6-3.4,5.3-5.1,7.5l1.6,1.2c1.7-2.2,3.7-5,5.3-7.7c1.5-2.7,2.7-5.6,2.7-8H29.5z M15.1,31.4 c-1.7-2.2-3.6-4.9-5.1-7.5c-1.5-2.7-2.5-5.2-2.5-7h-2c0,2.4,1.2,5.3,2.7,8c1.6,2.8,3.5,5.5,5.3,7.7L15.1,31.4z M7.5,16.9 c0-6.6,5-11.9,11-11.9V3c-7.2,0-13,6.3-13,13.9H7.5z M18.5,5c6,0,11,5.3,11,11.9h2c0-7.6-5.8-13.9-13-13.9V5z M21.9,31.4 c-0.9,1.2-1.5,2-2.1,2.5c-0.5,0.5-0.9,0.6-1.3,0.6v2c1.1,0,1.9-0.4,2.6-1.1c0.7-0.6,1.4-1.6,2.3-2.7L21.9,31.4z M13.5,32.7 c0.9,1.1,1.6,2.1,2.3,2.7c0.8,0.7,1.6,1.1,2.6,1.1v-2c-0.4,0-0.8-0.1-1.3-0.6c-0.6-0.5-1.2-1.3-2.1-2.5L13.5,32.7z M13,17.5 c0,3,2.5,5.5,5.5,5.5v-2c-1.9,0-3.5-1.6-3.5-3.5H13z M18.5,23c3,0,5.5-2.5,5.5-5.5h-2c0,1.9-1.6,3.5-3.5,3.5V23z M24,17.5 c0-3-2.5-5.5-5.5-5.5v2c1.9,0,3.5,1.6,3.5,3.5H24z M18.5,12c-3,0-5.5,2.5-5.5,5.5h2c0-1.9,1.6-3.5,3.5-3.5V12z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b77252a14e12876aca8236d64956cadc.svg";
export { ForwardRef as ReactComponent };